import {AddPodRoomCharacter, CheckAlreadyJoined} from '@/graphql/mutations/Pod.graphql'
import {GetModalAlertInfomations} from '@/graphql/queries/Character.graphql'

export default {
  computed  : {
    selectedCharacter(){
      return this.$store.state.connectionManageModal.character;
    },

    podRoom(){
      return this.$store.state.connectionManageModal.podRoom;
    }
  },

  apollo : {
    modalAlertInfomations : {
      query: GetModalAlertInfomations
    }
  },

  methods   : {
    emptyFlashMessageAddCharacter(){
      this.$store.dispatch({
        type        : 'flashMessage/updateFlashMessage',
        hasMessage  : true,
        message     : '&nbsp;きびだんごが不足しています。',
        status      : 'error',
        hasControl  : true,
        autoClose   : 8000
      }, {root:true});
    },

    alreadyJoginedFlashMessage(){
      this.$store.dispatch({
        type        : 'flashMessage/updateFlashMessage',
        hasMessage  : true,
        message     : '&nbsp;このキャラクターはすでに参加済みです。',
        status      : 'error',
        hasControl  : true,
        autoClose   : 8000
      }, {root:true});
    },

    async handleClickSubmitAddCharacterConfirmModal(){
      const characterItemStoreData = this.couldUseStoryItemValidation('kibidango');

      if( characterItemStoreData !== false ){
        this.$store.dispatch({
          type            : 'connectionManageModal/updateCharacterConfirmModal',
          isSubmitLoading : true
        });
  
        await this.UXWaiting(2000);

        // 指定したキャラクターがすでに参加済みかどうかを確認します。 
        if( await this.isCharacterAlreadyJoined() ){
          this.$store.dispatch({
            type            : 'connectionManageModal/updateCharacterConfirmModal',
            isSubmitLoading : false
          });

          this.alreadyJoginedFlashMessage();

          return;
        }

        this.displayUseStoryItemConfirmModal({
          characterItemStore    : characterItemStoreData,
          templateName          : 'addCharacterToPodRoom',

          itemRequireAmount     : 1,  // 使用するアイテムの数

          handleSubmitFunction  : async() => {
            this.$store.dispatch({
              type            : 'itemUseModal/updateOpenModal',
              isSubmitLoading : true,
            });
  
            await this.UXWaiting(1000);
  
            // ここでキャラクターをポットに投入する
            const result = await this.executeAddPodRoomCharacter();
  
            //アイテム消費確認モーダルを閉じる
            this.$store.dispatch({
              type            : 'itemUseModal/updateOpenModal',
              value           : false,
              isSubmitLoading : false
            });
  
            // キャラクター追加確認モーダルを閉じる
            this.$store.dispatch({
              type  : 'connectionManageModal/updateCharacterConfirmModal',
              value : false
            });
  
            if(result === true){
              //フラッシュメッセージで追加しましたを表示
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;メルティングポッドへの追加が完了しました。',
                status      : 'success',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});

              // ポイントモーダル用にrefetch;
              this.$apollo.queries.modalAlertInfomations.refetch();
            }else{
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;エラーが発生しました。',
                status      : 'error',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});
            }
          },

          handleCancelFunction  : async () => {
            this.$store.dispatch({
              type  : 'itemUseModal/updateOpenModal',
              value : false,
              isSubmitLoading : false
            });
          }
        });

        this.$store.dispatch({
          type            : 'connectionManageModal/updateCharacterConfirmModal',
          isSubmitLoading : false
        });
      }
    },

    isCharacterAlreadyJoined(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : CheckAlreadyJoined,
          variables : {
            characterId : this.selectedCharacter.id,
            podRoomId   : this.podRoom.id
          }
        }).then(async ({data:{CheckAlreadyJoined:{result}}}) => {
          resolve(result);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    },

    executeAddPodRoomCharacter(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : AddPodRoomCharacter,
          variables : {
            characterId : this.selectedCharacter.id,
            podRoomId   : this.podRoom.id
          },
          update    : (store, {data:{addPodRoomCharacterResult:{podRoom}}}) => {
            if(podRoom !== null){
              this.$apollo.queries.joinedPodRoomList.refetch();
              this.$apollo.queries.characterItemStoreList.refetch();
            }else{
              resolve(false);
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    }
  }
}